@if (order && order.items) {
  <table class="items">
    <thead>
      <tr>
        <th>Item</th>
        <th>Quantity</th>
        <th>Description</th>
        <th>Category</th>
        <th>Ready Date</th>
        <th>Eta</th>
      </tr>
    </thead>
    <tbody>
      @for (item of order.items; track item.itemNo) {
        <tr>
          <td>{{ item.itemNo }}</td>
          <td>{{ item.quantity }}</td>
          <td>
            <div [appEllipsisTooltip]="item.goodsDescription">{{ item.goodsDescription }}</div>
          </td>
          <td>
            <div [appEllipsisTooltip]="item.category">{{ item.category }}</div>
          </td>
          <td>{{ item.itemOrderReady | dateTimeFormat }}</td>
          <td>{{ item.eta | dateTimeFormat }}</td>
        </tr>
      } @empty {
        <tr>
          <td colspan="6" class="items__empty">No items found</td>
        </tr>
      }
    </tbody>
  </table>
} @else {
  <app-items-skeleton></app-items-skeleton>
}
